/**
 * Mapping of EShedulerTask enum values to human-readable job names and descriptions
 * Based on documentation in: GoogleAdsDownloader/cruise-control/backend/.prd/out/doc-cron.md
 */

export const JOB_NAMES_MAPPING = {
  'DUMMY': {
    name: 'Dummy Task',
    description: 'Test or placeholder task for development and testing purposes.'
  },
  'TEST': {
    name: 'Test Task',
    description: 'Test task for development and debugging purposes.'
  },
  'NoneTask': {
    name: 'No Task',
    description: 'Log records that are not associated with any specific scheduled task.'
  },
  'KYEWORDS_SYNC': {
    name: 'Keywords Sync',
    description: 'Synchronizes keyword data and performance metrics across advertising platforms.'
  },
  'COPPER': {
    name: 'Copper CRM Integration',
    description: 'Comprehensive synchronization system integrating FlameOff\'s order management, marketing, and customer data with Copper CRM. Manages complete lifecycle of leads, people, companies, and opportunities.'
  },
  'COPPER_UPDATE_LEADS_PEOPLE': {
    name: ' Copper Leads and People Update',
    description: 'Synchronizes leads and people (contacts) data between internal database and Copper CRM. Fetches current data from Copper CRM, matches against recent internal lead sources, and updates existing CRM records.'
  },
  'COPPER_SYNC_CRM_NOTES': {
    name: 'Copper CRM Notes Sync',
    description: 'Synchronizes call metadata from internal database (CallRail) to Copper CRM as activity notes. Processes AI-reviewed call records and creates corresponding notes with call details.'
  },
  'COPPER_DAYLY': {
    name: 'Copper Daily Activity',
    description: 'Updates activity history for Copper CRM contacts stored in marketing database. Fetches latest activities from Copper CRM API for people and leads, and generates potential gallons report.'
  },
  'UPDATE_ANALYTICS': {
    name: 'Depricated - Update Analytics',
    description: 'Updates analytics data from various sources for reporting and analysis purposes.'
  },
  'SALES_RECEIPT': {
    name: 'Sales Receipt to QuickBooks',
    description: 'Synchronizes sales orders from FlameOff database to QuickBooks Online by creating and updating customers and sales receipts. Fetches new orders from last 14 days.'
  },
  'UPDATE_BING_ADS': {
    name: 'Bing Ads Update',
    description: 'Data synchronization system importing Bing Ads campaign data, ad groups, keywords, and performance metrics into internal database. Processes CSV reports and updates with automated bid adjustments.'
  },
  'SENDINBLUE': {
    name: 'SendinBlue Integration',
    description: 'Synchronizes email marketing campaign data from SendinBlue with internal database. Tracks email campaign performance metrics and attributes customer orders to specific email campaigns.'
  },
  'GOALS_ANALYTICS': {
    name: 'Google Analytics Goals',
    description: 'Critical marketing attribution system integrating with Google Analytics Reporting API v4 to track user activity and attribute orders to keywords/campaigns. Enriches order data with GA client IDs and search queries.'
  },
  'BING_REPORT_DWN_SERVICE': {
    name: 'Bing Entity Ads Bulk Service Download',
    description: 'Downloads bulk advertising data from Microsoft Bing Ads API. Retrieves comprehensive campaign, ad group, ad, and keyword data including quality scores and bid suggestions.'
  },
  'INTEGRAL_CALCULATION': {
    name: 'Integral Calculation',
    description: 'Calculates cost-per-gallon metrics using moving average approach. Analyzes relationship between advertising spend and sales volume across 7-day, 30-day, and 12-week rolling periods.'
  },
  'RANK_UPDATE': {
    name: 'Keyword Ranking & Bid Optimization',
    description: 'Automated system calculating performance rankings for keywords across Google Ads and Bing campaigns, then automatically adjusting keyword bids based on calculated scores using multi-factor algorithm.'
  },
  'UPDATE_ORDERS_LEADS_MAPPING': {
    name: 'Update Orders & Leads',
    description: 'Comprehensive synchronization system importing orders from Hub database, matching with leads from multiple sources, performing keyword/campaign attribution, and maintaining marketing database.'
  },
  'UPDATE_ORDERS_LEADS_DAILY': {
    name: 'Daily Update Orders and Leads',
    description: 'Critical data synchronization linking customer orders with advertising source attribution. Processes call records and web inquiries to identify which keywords/campaigns generated each order.'
  },
  'DEILY_UPDATE_LEADS': {
    name: 'Daily Update Leads Attribution',
    description: 'Performs lead attribution and matching for sales orders. Correlates web inquiries and phone calls with orders using email addresses, phone numbers, and order IDs.'
  },
  'REFRESH_ACTIVE_CAMPAING': {
    name: 'Active Campaign Refresh',
    description: 'Synchronizes Google Ads campaign, ad group, and keyword data with local database. Fetches campaign structures, keyword performance metrics, updates keyword estimates, costs, and conversions.'
  },
  'REDIS_CACHING_TASK': {
    name: 'Redis Caching Task',
    description: 'Triggers cache refresh for various reports including Potential Gallons Report, Customer Report, and Keyword Report. Pre-calculates expensive query results for performance optimization.'
  },
  'AD_GOOGLE_DOWNLOADER': {
    name: 'Google Ads Downloader',
    description: 'Downloads performance data from Google Ads API v19. Supports multiple report types: Ad Performance, Keyword Performance, Campaign Performance, Budget Performance, and Search Query Performance.'
  },
  'GMAIL_TASK': {
    name: 'Pull Web Inquiries from Gmail',
    description: 'Automated email processing system monitoring Gmail inbox for customer inquiries from website contact forms. Extracts structured data, validates information, and stores in database for lead tracking.'
  },
  'BING_REPORT_REQUEST': {
    name: 'Bing Ads Performance Report Downloader',
    description: 'Downloads performance reports from Microsoft Bing Ads API. Downloads Keyword Performance and Campaign Performance reports in CSV format with daily aggregated data.'
  },
  'SENDPULSE_INTEGRATION': {
    name: 'SendPulse Campaign Statistics Update',
    description: 'Synchronizes email campaign statistics from SendPulse API to local database. Fetches all email campaigns with performance metrics and matches campaigns with customer orders to calculate conversion rates.'
  },
  'ATTACH_CALL_AND_CAMPAING': {
    name: 'Attach Calls & Web Inquiries with Keywords',
    description: 'Automated keyword and campaign assignment system mapping CallRail calls and web inquiries to internal keyword and campaign IDs. Propagates keyword assignments to order leads.'
  },
  'FEEDBACK_MAILING': {
    name: 'Customer Feedback Email Mailing',
    description: 'Automatically sends customer satisfaction survey emails to customers who placed orders 14-28 days ago. Creates email records, generates unique survey tokens, and sends personalized feedback requests.'
  },
  'QUICK_BOOKS_MIGRATION': {
    name: 'QuickBooks Migration',
    description: 'Migrates financial and sales data from QuickBooks Online to local SQL Server database. Synchronizes customers, invoices, sales receipts, bills, purchase orders, and purchases for business analytics.'
  },
  'GRASSHOPPERSPIDER': {
    name: 'Grasshopper Migration',
    description: 'Downloads call detail records from Grasshopper phone system using Scrapy web scraping framework. Authenticates with Grasshopper, generates reports for last 30 days, and imports call data to database.'
  },
  'KEYWORDS_SPEND_CHINING': {
    name: 'Keyword Spending Check & Notifications',
    description: 'Monitors keyword spending against configured budgets and sends email notifications when keywords exceed spending thresholds. Runs as part of chained command after Google Ads download.'
  },
  'SENDING_NOTIFICATION_EMAILS': {
    name: 'Spending Notifications Emails',
    description: 'Sends email notifications about advertising spending alerts. Runs as final step in chained command after keyword spending check completes.'
  },
  'RURAL_IMPORT_CALLRAIL': {
    name: 'Rural Import CallRail Calls & Web Inquiries',
    description: 'Imports call records and web inquiries from CallRail into the Rural CRM system for lead tracking and attribution.'
  },
  'SELNETICS_IMPORT_QUOTES': {
    name: 'Sellnetics Import Quotes From Hub',
    description: 'Imports quote data from Sellnetics system into the central database for tracking and analysis of potential sales opportunities.'
  },
  'SENDPULSE_LIST_CUSTOMER_SYNC': {
    name: 'SendPulse List Import',
    description: 'Synchronizes email subscriber status from SendPulse to internal Rural/Selnetics API. Fetches active subscribers and unsubscribed contacts from specific SendPulse mailing list.'
  },
  'SELLNETICS_COPPER_SYNC_DATA': {
    name: 'Sync Sellnetics to Copper Contacts',
    description: 'Bidirectional synchronization between Sellnetics (FlameOff) database and Copper CRM. Creates new Copper leads for Sellnetics contacts and updates Sellnetics contacts with Copper profile URLs.'
  },
  'UPDATE_MAPPING_KEYWORDS_CAMPAIGNS': {
    name: 'Fill Keywords Mappings',
    description: 'Automatically creates and maintains mappings between external campaign/keyword data (from CallRail calls, web inquiries, and orders) and internal Google Ads/Bing Ads campaign and keyword IDs.'
  },
  'RURAL_IMPORT_CONTACT_FROM_ORDERS': {
    name: 'Import Orders, Estimations & Quotes to Contacts',
    description: 'Automated data synchronization importing orders, estimator projects, and quotes from various source databases into Rural CRM system. Creates or updates contact records and associated events.'
  },
  'RURAL_IMPORT_CONTACT_FROM_APPLICATORS': {
    name: 'Applicators Certification Automation',
    description: 'Automates the process of importing and managing applicator certification data into the system for tracking and compliance purposes.'
  },
  'All': {
    name: 'All Tasks',
    description: 'View all job types without filtering.'
  }
};

/**
 * Get readable name for a job
 * @param {string} jobKey - The EShedulerTask enum value
 * @returns {string} Human-readable job name
 */
export function getJobReadableName(jobKey) {
  const jobInfo = JOB_NAMES_MAPPING[jobKey];
  if (typeof jobInfo === 'object' && jobInfo.name) {
    return jobInfo.name;
  }
  return jobKey;
}

/**
 * Get description for a job
 * @param {string} jobKey - The EShedulerTask enum value
 * @returns {string} Job description
 */
export function getJobDescription(jobKey) {
  const jobInfo = JOB_NAMES_MAPPING[jobKey];
  if (typeof jobInfo === 'object' && jobInfo.description) {
    return jobInfo.description;
  }
  return '';
}

/**
 * Get all job names as array of objects for v-select
 * @param {Array<string>} jobKeys - Array of job enum values
 * @returns {Array<{value: string, text: string, description: string}>} Array of objects with value, text, and description
 */
export function getJobNamesForSelect(jobKeys) {
  return jobKeys.map(key => ({
    value: key,
    text: getJobReadableName(key),
    description: getJobDescription(key)
  }));
}

